module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/list/project-list-item/project-list-item.component.scss
// module id = ./src/app/projects/list/project-list-item/project-list-item.component.scss
// module chunks = main